import type { BaseController } from '@infra/controllers/base.controller';
import type { TransferNumberUsecase } from './warm-transfer-call.usecase';

export type TransferNumberInput = {
  callId: string;
  phoneNumber: string;
  name?: string;
};

export type TransferNumberOutput = void;

export class TransferNumberController
  implements BaseController<TransferNumberInput, TransferNumberOutput>
{
  constructor(private usecase: TransferNumberUsecase) {}

  async handle({
    callId,
    phoneNumber: to,
    name,
  }: TransferNumberInput): Promise<TransferNumberOutput> {
    await this.usecase.run({ callId, to, name });
  }
}
